import { render, staticRenderFns } from "./kiem-soat-don-hang.vue?vue&type=template&id=636ed289&"
import script from "./kiem-soat-don-hang.vue?vue&type=script&lang=js&"
export * from "./kiem-soat-don-hang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports